import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-edit',
	path: '/secure/admin/EditFieldScreen!default.jspa',
};
